import angular from "angular";

angular.module('ui-sentinel.devices.deviceReportToolItem', [
    'ui-sentinel.devices'
]);
